// MyUploadAdapter.js
const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_BASE_URL = API_ROOT.endsWith('/api')
  ? API_ROOT
  : `${API_ROOT.replace(/\/$/, '')}/api`;
const MEDIA_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

class MyUploadAdapter {
    constructor(loader) {
      this.loader = loader;
    }
  
    upload() {
      return this.loader.file.then(
        file =>
          new Promise((resolve, reject) => {
            const data = new FormData();
            data.append('files', file);
  
            fetch(`${API_BASE_URL}/upload-many/`, {
              method: 'POST',
              body: data,
            })
              .then(response => response.json())
              .then(result => {
                resolve({
                  default: `${MEDIA_BASE_URL}${result[0].path}`,
                });
              })
              .catch(error => {
                reject(error);
              });
          })
      );
    }
  
    abort() {
      // Handle abort
    }
  }
  
  export function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = loader => {
      return new MyUploadAdapter(loader);
    };
  }
  
